export const SPECIAL_USERS = [
  'domotor.haasz@solidagency.hu',
  'patrik.gaal@heineken.hu',
  'emese.magyar@heineken.hu',
  'laszlo.bardkai@heineken.hu',
  'zita.laczay@heineken.hu',
  'heineken+1@modolit.com',
];
